// extracted by mini-css-extract-plugin
export default {"title":"stageGroups_title__cB-eh","actionButton":"stageGroups_actionButton__1Q51c","disabledRow":"stageGroups_disabledRow__0LpDS","button":"stageGroups_button__QPaM8"};